import Snackbar from '@mui/material/Snackbar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
export const SnackbarComponent = ({
  open,
  setOpen,
  message,
  type,
  style,
  keepOpened,
  successIcon,
  failureIcon,
}: {
  open: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  message: string | JSX.Element;
  type?: 'success' | 'faliure' | 'normal';
  style: object;
  keepOpened?: boolean | undefined;
  successIcon?: JSX.Element;
  failureIcon?: JSX.Element;
}) => {
  const handleClose = () => {
    if (setOpen && !keepOpened) {
      setOpen(false);
    }
  };
  return (
    <Snackbar
      id="snackbar-component"
      autoHideDuration={2500}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={handleClose}
      sx={style}
    >
      <p
        id="snackbar-component_message"
        style={{ margin: '0px', display: 'flex', alignItems: 'center', textAlign: 'center', padding: '10px' }}
      >
        {type === 'success'
          ? successIcon || <CheckCircleOutlineIcon sx={{ color: 'success.main', marginRight: '20px' }} />
          : type === 'faliure'
          ? failureIcon || <ReportProblemOutlinedIcon sx={{ color: 'red', marginRight: '20px' }} />
          : null}
        {message}
      </p>
    </Snackbar>
  );
};
